import { Outlet } from 'react-router-dom';
import Layout from '../global/Layout';
import { useTranslation } from 'react-i18next';
import { useKirbyDemoContent } from '../../hooks/useKirbyData';

const TutorialsDemoWrapperPage: React.FC = () => {
  const { t } = useTranslation();
  const { data: demoContent } = useKirbyDemoContent();

  return (
    <Layout showSidebar>
      <h1>{demoContent?.online_demo_title || t('pages.tutorialsDemo.title')}</h1>
      <Outlet />
    </Layout>
  );
};

export default TutorialsDemoWrapperPage;
